var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 31,
    viewBox: "0 0 39 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "lx47ykivua",
    x: 0,
    y: 0,
    width: 39,
    height: 31,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#lx47ykivua)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 769",
    width: 27,
    height: 19,
    rx: 5,
    transform: "translate(6 5)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 885",
    d: "M.547 10.315a.547.547 0 0 1 .547.547v3.828a1.094 1.094 0 0 0 1.094 1.094h13.126a1.094 1.094 0 0 0 1.094-1.094v-3.828a.547.547 0 1 1 1.094 0v3.828a2.188 2.188 0 0 1-2.188 2.188H2.188A2.188 2.188 0 0 1 0 14.691v-3.829a.547.547 0 0 1 .547-.547zm4.922-3.441a.547.547 0 0 0 .773 0l2.509-2.509 2.508 2.508a.547.547 0 1 0 .773-.773L9.138 3.205a.547.547 0 0 0-.774 0L5.469 6.1a.547.547 0 0 0 0 .774z",
    style: {
      fill: "#777",
      fillRule: "evenodd"
    },
    transform: "translate(10.749 4.599)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 886",
    d: "M17.422 4.5a.547.547 0 0 1 .547.547V13.8a.547.547 0 1 1-1.094 0V5.047a.547.547 0 0 1 .547-.547z",
    transform: "translate(2.078 3.851)",
    style: {
      fill: "#777",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.50ca7c373f69433d63ffebb3c6d13c0d.svg";
export { ForwardRef as ReactComponent };